import { render, staticRenderFns } from "./sourcingVerify.vue?vue&type=template&id=b57c3f86&scoped=true"
import script from "./sourcingVerify.vue?vue&type=script&lang=js"
export * from "./sourcingVerify.vue?vue&type=script&lang=js"
import style0 from "./sourcingVerify.vue?vue&type=style&index=0&id=b57c3f86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57c3f86",
  null
  
)

export default component.exports